import styles from './Skeleton.module.css'

export interface SkeletonProps {
  className?: string
  style?: React.CSSProperties
}

export function Skeleton({ className, style }: SkeletonProps) {
  return <div className={[styles.skeleton, className].filter(Boolean).join(' ')} style={style} />
}
